document.addEventListener('DOMContentLoaded', function () {
  var CARRUSEL_50_ACTIVO = false;        // <- ponlo en true para reactivarlo
  if (!CARRUSEL_50_ACTIVO) return;       // <- apagado: no hace nada
  
  var TITULO_DESCUENTO = 'AMAZING price.';

  var fetchOriginal = window.fetch;

  window.fetch = function () {
    var peticion = fetchOriginal.apply(this, arguments);
    var url = arguments[0];
    var urlTexto = (typeof url === 'string') ? url : (url && url.url) || '';

    if (urlTexto.indexOf('/cart/add') !== -1 ||
        urlTexto.indexOf('/cart/change') !== -1 ||
        urlTexto.indexOf('/cart/update') !== -1) {
      peticion.then(function () {
        setTimeout(actualizarPreciosCarrusel, 500);
      });
    }

    return peticion;
  };

  function actualizarPreciosCarrusel() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var idsEnCarrito = cart.items.map(function (item) { return item.product_id; });
        var contenedorWidget = document.querySelector('[data-excluidos]');
        var excluidos = contenedorWidget
          ? contenedorWidget.dataset.excluidos.split(',').map(Number)
          : [];

        // Comprobamos si el descuento REAL ya fue consumido por algún
        // producto del carrito (Shopify lo indica en item.discounts).
        var descuentoYaUsado = cart.items.some(function (item) {
          return (item.discounts || []).some(function (d) {
            return d.title === TITULO_DESCUENTO;
          });
        });

        document.querySelectorAll('[data-upsell-price-product-id]').forEach(function (el) {
          var pid = parseInt(el.dataset.upsellPriceProductId, 10);
          var yaEstaEnCarrito = idsEnCarrito.indexOf(pid) !== -1;

          var hayCondicionCumplida = idsEnCarrito.some(function (id) {
            return id !== pid && excluidos.indexOf(id) === -1;
          });

          // Solo mostramos descuento si: no está ya en el carrito,
          // hay un producto "gancho" válido, Y el cupo del descuento
          // (Quantity: 1) todavía no se ha consumido por otro producto.
          var hayOtro = !yaEstaEnCarrito && hayCondicionCumplida && !descuentoYaUsado;

          var precioOriginal = parseInt(el.dataset.upsellPriceOriginal, 10);
          var pct = parseInt(el.dataset.upsellDiscountPct, 10);

          var spanNuevo = el.querySelector('.new-price');
          var spanViejo = el.querySelector('.old-price');

          if (hayOtro) {
            var rebajado = precioOriginal - Math.round(precioOriginal * pct / 100);
            if (spanNuevo) spanNuevo.textContent = formatearPrecio(rebajado);
            if (!spanViejo) {
              spanViejo = document.createElement('span');
              spanViejo.className = 'old-price';
              el.appendChild(spanViejo);
            }
            spanViejo.textContent = formatearPrecio(precioOriginal);
            el.classList.add('sale');
          } else {
            if (spanNuevo) spanNuevo.textContent = formatearPrecio(precioOriginal);
            if (spanViejo) spanViejo.remove();
            el.classList.remove('sale');
          }
        });
      })
      .catch(function (err) {
        console.error('Error al actualizar precios del carrusel:', err);
      });
  }

  function formatearPrecio(centavos) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(centavos);
    }
    return '$' + (centavos / 100).toFixed(2);
  }
});